import 'Plugins/accordionPlugin';

// accordion menu init
export default function initAccordion() {
  jQuery('.accordion-media').slideAccordion({
    opener: '.opener',
    slider: '.slide',
    animSpeed: 300
  });

  jQuery(document).on("click", ".opener", e => {
    const indicator = $(e.target).children(":first");
    indicator.toggleClass("fa-map fa-minus");
    indicator.toggleClass("far fas");
    $(".indicator").not(indicator).attr("class", "indicator far fa-map");
  });
}
